import AppBar from "@mui/material/AppBar";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import { TransitionProps } from "@mui/material/transitions";
import Typography from "@mui/material/Typography";
import { Icons } from "assets";
import React, { useState } from "react";
import styles from "./style.module.scss";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import classNames from "classnames";
import TransactionGraph from "shared/components/projectHeadComponents/transaction/transactionGraph";

const tabs = [
  {
    value: 0,
    label: "Parents",
  },
  {
    value: 1,
    label: "Indiviuals",
  },
  {
    value: 2,
    label: "Schools",
  },
];

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface FullScreenStatsCardProps {
  open: boolean;
  handleClose: () => void;
  label: string;
}

export default function FullScreenStatsCard({
  open,
  handleClose,
  label,
}: FullScreenStatsCardProps) {
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          className: styles.main,
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
              component="div"
              className={styles.heading}
            >
              {label}
            </Typography>
            <button className={styles.closeBtn} onClick={handleClose}>
              <Icons.CrossIcon />
            </button>
          </Toolbar>
        </AppBar>

        <div className={styles.mainContainer}>
          <TransactionGraph />
        </div>
      </Dialog>
    </React.Fragment>
  );
}
